import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-space-between full-height" }
const _hoisted_2 = { class: "text-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Crée le ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_title = _resolveComponent("app-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_notification = _resolveComponent("notification")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "full-height"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "space-between",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3",
            class: "mt-md-10 pl-md-12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_app_title, { title: "Mes contributions" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.getPollsBySearch.length > 0)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_pagination, {
                modelValue: _ctx.pollsPaginated.page,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pollsPaginated.page) = $event)),
                  _ctx.onPaginationChange
                ],
                length: _ctx.pollsPaginated.totalPages
              }, null, 8, ["modelValue", "length", "onUpdate:modelValue"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_notification, {
                    message: "Vous n'avez pas encore contribué à un sondage",
                    permanent: "",
                    closable: false,
                    "min-width": 1000,
                    "min-height": 50,
                    type: _ctx.NotificationType.INFO
                  }, null, 8, ["type"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      (_ctx.getPollsBySearch.length > 0)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPollsBySearch, (poll, index) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: index,
                  cols: "12",
                  md: "4",
                  class: "pa-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "pa-5",
                      height: "100%",
                      onClick: ($event: any) => (_ctx.onPollRedirect(poll))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h2", null, _toDisplayString(poll.name), 1),
                            _createElementVNode("p", null, _toDisplayString(poll.description), 1)
                          ]),
                          _createElementVNode("p", _hoisted_2, [
                            _hoisted_3,
                            _createTextVNode(),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatLocaleDateTime(poll.createDate)), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}